import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class ProductivityService {
  // tslint:disable-next-line:typedef
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getOEE(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetOEEDashboard', data);
  }

  getMaintenance(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetMaintenanceDashboard', data);
  }

  getProductionQualityData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetOEEDashboard', data);
  }

  getProductionShiftData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'SDFC/GetShiftDetailsByUnit', data);
  }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetEnterpriseList', data);
  }

  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetPlantList', data);
  }

  // getLineData(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetLineList', data);
  // }
  getLineData(data: any): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'Dashboard/GetLineList');
  }

  getUnitDataByMultipleLines(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitList', data);
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitListByMultipleLine', data);
  }

  getLineByDeptData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetLineListByDept', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUnitList', data);
  }

  getComponentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetComponentList', data);
  }

  getUOMData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetUOM', data);
  }

  submitProductionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlan', data);
  }

  getProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProductionPlanDetail', data);
  }

  getProducts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/GetProducts', data);
  }

  submitProductionPlanDetail(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Planner/SubmitProductionPlanDetail', data);
  }

  getOEEANDAPQ(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetDailyOEEANDAPQDashboard', data);
  }

  GetAdminInfoDashboard(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetAdminInfoDashboard', data);

  }

  GetEnergyDashboard(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetEnergyDashboard', data);

  }
  getVariableGroup(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetVariableGroupList', data);
  }

  getVariableGroupParametrs(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Variable/getVariableGroupVariables', data);
  }

  getParameterAnalysisDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetParameterAnalysisDashboard', data);
  }

  //======================== Downtime Pareto Dashboard===============================================//
  getDTParetoDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ParetoAnalysis/GetParetoDashboard', data);
  }
  getFaultList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'ParetoAnalysis/GetFaultDurationDetails', data);
  }
  //==============================MOngoDB service=======================================//
  getDashboardDataMongo(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Mongodb/GetTagValues', data);
  }

  createParameterTarget(payload: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}PMTaskParamterTarget/CreateParameterTarget`, payload);
  }

  getParameterTarget(taskId: any): Observable<any> {
    return this.http.get(`${this.baseUrl}PMTaskParamterTarget/GetParameterTargetsByTask/${taskId}`);
  }
  deleteParameterTarget(id: number, updatedBy: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}PMTaskParamterTarget/DeleteParameterTarget/${id}/${updatedBy}`);
  }

}